// extracted by mini-css-extract-plugin
module.exports = {"vertical-align":"Pages_vertical-align__2csFY"};